/**
 * 淡出并移除 index.html 注入的首屏 loading 与样式。
 * 鉴权初始化期间保留它，避免 OIDC 跳转前出现白屏。
 */
export function dismissBootSplash(): void {
  const splash = document.getElementById("__app-loading__");
  if (!splash) {
    return;
  }

  const injected = document.querySelectorAll('[data-app-loading^="inject"]');
  const cleanup = () => {
    splash.remove();
    injected.forEach((element) => {
      element.remove();
    });
  };

  splash.addEventListener("transitionend", cleanup, { once: true });
  splash.dataset.state = "out";
  window.setTimeout(cleanup, 600);
}
